import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from "@chakra-ui/react";
import AppRouter from './AppRouter';
import theme from './themes/Main';
import './i18n';
import { LoadScript } from '@react-google-maps/api';
import { Analytics } from '@vercel/analytics/react';
import DelayedSpinner from './ui/feedback/Spinner';
import SWRProvider from './components/SWRProvider';

// Ajouter la police Poppins au head
const poppinsLink = document.createElement('link');
poppinsLink.rel = 'stylesheet';
poppinsLink.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap';
document.head.appendChild(poppinsLink);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <SWRProvider>
    <ChakraProvider
      theme={theme}
      toastOptions={{
        defaultOptions: {
          position: 'top',
          duration: 3000,
          isClosable: true,
          variant: 'subtle',
        },
      }}
    >
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        libraries={["places"]}
        loadingElement={<DelayedSpinner minDelay={100} />}
      >
        <AppRouter />
      </LoadScript>
      {/* Vercel Web Analytics — counts visitors & page views (SPA route changes
          tracked automatically). Renders nothing; data shows in the Vercel dashboard. */}
      <Analytics />
    </ChakraProvider>
  </SWRProvider>
);

